import React, { useState } from "react";
import { Card } from "antd";
import Chatbox from "../../components/chat/PCLMChatbox";

export default function ChatSection() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="pclm-menu-section" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <Card className={`pclm-menu-card ${isHovered ? "pclm-card-hovered" : ""}`}>
        <div className="pclm-chatbox">
          <Chatbox />
        </div>
      </Card>
    </div>
  );
}
